import { useState, useRef } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import Alert from "../components/Alert";
import { useNavigate } from "react-router-dom";


const AddProduct = () => {
  const [form, setForm] = useState({ name: "", information: "", price: "", image: null, category: "" });
  const [formError, setFormError] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [success, setSuccess] = useState(null);
  const fileInputRef = useRef();
  const navigate = useNavigate();
  const API_BASE_URL = 'https://api.tenarx.net';
  const validateForm = () => {
    if (!form.name.trim() || !form.information.trim() || !form.price || !form.image || !form.category) {
      setFormError("All fields are required, including image and category.");
      return false;
    }
    if (isNaN(form.price) || Number(form.price) <= 0) {
      setFormError("Price must be a positive number.");
      return false;
    }
    setFormError(null);
    return true;
  };

  const handleInput = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setForm((prev) => ({ ...prev, image: files[0] }));
      setImagePreview(files[0] ? URL.createObjectURL(files[0]) : null);
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setFormLoading(true);
    setSuccess(null);
    setFormError(null);
    try {
      const token = localStorage.getItem("userToken");
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("information", form.information);
      formData.append("price", form.price);
      formData.append("image", form.image);
      formData.append("category", form.category);
      const res = await fetch(`${API_BASE_URL}/api/products`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess("Product added successfully!");
        alert("Product added successfully!");
        console.log("Success:", data);
        setForm({ name: "", information: "", price: "", image: null, category: "" });
        setImagePreview(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        setTimeout(() => navigate("/products/list"), 1200);
      } else {
        setFormError(data.message || "Failed to add product");
        alert(data.message || "Failed to add product");
        console.error("Error:", data);
      }
    } catch (err) {
      setFormError("Failed to add product");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <Layout title="Add Product">
      <div className="max-w-lg mx-auto py-8">
        <Card>
          <h2 className="text-xl font-bold mb-4">Add Product</h2>
          {formError && <Alert type="error" message={formError} />}
          {success && <Alert type="success" message={success} />}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleInput}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Product name"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Information</label>
              <textarea
                name="information"
                value={form.information}
                onChange={handleInput}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Product information"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Price</label>
              <input
  type="text"
  name="price"
  value={form.price}
  onChange={(e) => {
    let value = e.target.value;

    // ✅ Allow: numbers, optional decimal with ".", and at most 1 letter suffix
    if (/^\d*\.?\d*[A-Za-z]?$/.test(value)) {
      handleInput({ target: { name: "price", value } });
    }
  }}
  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"

  required
/>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Category</label>
              <select
                name="category"
                value={form.category}
                onChange={handleInput}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select category</option>
                <option value="Hair care">Hair care</option>
                <option value="Baby care">Baby care</option>
                <option value="Skin care">Skin care</option>
                <option value="Vitamins & Supplements">Vitamins & Supplements</option>
                <option value="Diabetes">Diabetes</option>
                <option value="First Aid & Surgeries">First Aid & Surgeries</option>
                <option value="Fitness & Nutrition">Fitness & Nutrition</option>
                <option value="Sexual Health">Sexual Health</option>
                <option value="Pain Relief">Pain Relief</option>
                <option value="Women's care">Women's care</option>
                <option value="Heart Health">Heart Health</option>
                <option value="Digestive Health">Digestive Health</option>
                <option value="Mental Health">Mental Health</option>
                <option value="Sleep & Relaxation">Sleep & Relaxation</option>
                <option value="Allergy & Sinus">Allergy & Sinus</option>
                <option value="Health Devices">Health Devices</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Image</label>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleInput}
                ref={fileInputRef}
                className="w-full"
                required
              />
              {imagePreview && (
                <img src={imagePreview} alt="Preview" className="w-32 h-20 object-cover rounded mt-2" />
              )}
            </div>
            <Button type="submit" disabled={formLoading} className="w-full">
              {formLoading ? "Adding..." : "Add Product"}
            </Button>
            <Button type="button" variant="secondary" className="w-full" onClick={() => navigate("/products/add")}>Back to Products</Button>
          </form>
        </Card>
      </div>
    </Layout>
  );
};

export default AddProduct;